module.exports = __webpack_public_path__ + "img/align-2.7184d653.svg";